"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shoeCareProductType = void 0;
const core_attributes_1 = require("./core-attributes");
const variant_attributes_1 = require("./variant-attributes");
const common_1 = require("./common");
exports.shoeCareProductType = {
    name: 'Shoe care',
    key: common_1.ProductTypesEnum.SHOE_CARE,
    description: 'Shoe care',
    attributes: [
        core_attributes_1.styleCode,
        core_attributes_1.styleName,
        core_attributes_1.shortColor,
        core_attributes_1.mediumColor,
        core_attributes_1.brand,
        core_attributes_1.productType,
        core_attributes_1.productSubType,
        core_attributes_1.season,
        core_attributes_1.seasonYear,
        core_attributes_1.seasonIntroduced,
        core_attributes_1.subBrand,
        core_attributes_1.gender,
        core_attributes_1.featureDescription,
        core_attributes_1.videoUrl,
        core_attributes_1.spinUrl,
        core_attributes_1.countryOfOrigin,
        core_attributes_1.vertexTaxGroup,
        // variant attributes
        // it is unlikely that size and fit will present for all shoe care products and variants
        (0, variant_attributes_1.globalSize)('None', false),
        (0, variant_attributes_1.globalFit)('None', false),
        variant_attributes_1.variantLength,
        variant_attributes_1.variantWidth,
        variant_attributes_1.variantHeight,
        variant_attributes_1.variantWeight,
        variant_attributes_1.ean,
        variant_attributes_1.upc,
        variant_attributes_1.ukFit,
        variant_attributes_1.usFit,
        variant_attributes_1.euFit,
        variant_attributes_1.ukSize,
        variant_attributes_1.usSize,
        variant_attributes_1.euSize,
        variant_attributes_1.pairsPerCarton,
    ],
};
//# sourceMappingURL=shoe-care.js.map